import React from 'react';
import { Segment } from 'semantic-ui-react';

const Footer = () => {
	const footerStyle = {
		// position: 'fixed',
		// left: '0',
		// bottom: '0',
		// width: '100vw',
		// right: '0',
	};

	return (
		<div style={footerStyle}>
			<Segment inverted vertical textAlign="center">
				© 2022 Kevin L. Schwartz. All rights reserved.
			</Segment>
		</div>
	);
};

export default Footer;
